export const baseConfig = {
  ticketConfig: {
    aid: '1233',
    appKey: 'magellan-web',
    clientType: 2
  },
  features: {
    showRegionItem: true,
    privacyPolicyLink: '',
    trackOrigin: 'L2L',
    defaultRegion: 'CN'
  },
  language: {
    switchLang: [
      'en',
      'id-ID',
      'vi-VN',
      'th-TH',
      'ms-MY',
      'es',
      'de-DE',
      'it-IT',
      'fr',
      'es-419',
      'pt-BR',
      'ja-JP',
      'zh-CN',
      'nl-NL',
      'pl-PL'
    ],
    defaultLang: 'en'
  }
};
